import React from 'react'
import { CarouselQuotes, TestimoniAdder } from '../../../components'
import auth from '../../../utils/auth'

const data = [
  {
    text: "I-KHUB sangat membantu saya sebagai peneliti dalam mencari data tentang ekstremisme kekerasan di Indonesia. Semoga I-KHUB semakin lengkap datanya dan semakin nyaman digunakan.",
    name: "Joshua, Peneliti",
  },
  {
    text: "I-KHUB sangat membantu saya sebagai peneliti dalam mencari data tentang ekstremisme kekerasan di Indonesia. Semoga I-KHUB semakin lengkap datanya dan semakin nyaman digunakan.",
    name: "Joshua, Peneliti",
  }
]

const TestimoniSection = () => {
  const { isOfficial } = auth()

  return (
    <div className="w-full lg:w-7/12">
      <div className="mb-4 lg:mb-8">
        <CarouselQuotes title="Testimonials" data={data} />
      </div>

      {
        isOfficial &&
        <TestimoniAdder />
      }
    </div>
  )
}

export { TestimoniSection }
